module.exports = __webpack_public_path__ + "img/newhomebg.5001ece5.png";